import React, { 
    useState,
    useEffect
}                               from 'react';
import { useSelector }          from 'react-redux';
import ErrorPage                from '../../infrastructure/views/error-page';

export const ErrorBoundary = props => {
    const [ s, setState ]   = useState({
        hasError: false
    });
    const redux             = useSelector( state => ({
        errorBoundaryCatchStatus    : state.getIn([ 'ui', 'provider', 'errorBoundaryCatchStatus' ])
    }));

    useEffect(() => {
        if (redux.errorBoundaryCatchStatus) {
            setState({
                hasError: true
            });
        }
    }, [ redux.errorBoundaryCatchStatus ])

    return (
        s.hasError
            ? <ErrorPage />
            : props.children
    );
}
 
export default ErrorBoundary;